/**
 * Shared base64url <-> Uint8Array helpers.
 *
 * Previously duplicated across SafeContext, EventsPage, ItemDetailPage,
 * familyKeys (private), and a fourth callsite (OrgDetailPage / Phase 3
 * promote handler) — lifted here so all pages share one definition.
 */

export function base64UrlToBytes(b64url: string): Uint8Array {
  const pad = b64url.length % 4 === 0 ? '' : '='.repeat(4 - (b64url.length % 4));
  const std = (b64url + pad).replace(/-/g, '+').replace(/_/g, '/');
  return Uint8Array.from(atob(std), (c) => c.charCodeAt(0));
}

export function bytesToBase64Url(b: Uint8Array): string {
  let s = '';
  for (const c of b) s += String.fromCharCode(c);
  return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
